/** Alineado con API `App\Entities\Theme` */
export const LIGHT_THEME = 1;
export const DARK_THEME = 2;
